module.exports = __webpack_public_path__ + "static/assets/f0785627f1ddc68d155f140c65772e70.png";